<h2 mat-dialog-title>{{ title() }}</h2>

<mat-dialog-content>
  <form [formGroup]="adsForm">
    <h3>Bannerdetails</h3>

    <div class="row">
      <div class="col-md-6">
        <input type="hidden" formControlName="id"/>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Ad titel</mat-label>
          <input matInput autocomplete="off" placeholder="Ad titel" formControlName="title">
          @if (adsForm.get('title')?.hasError('required')) {
            <mat-error>
              Titel ist erforderlich
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Link</mat-label>
          <input matInput autocomplete="off" formControlName="link" placeholder="Link" (blur)="onLinkBlur()">
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <phx-drag-drop
          (readFiles)="onImageSelected($event)"
          (clearFiles)="clearImageSelection()"
          [acceptedFileTypes]="'image'"
          [imgSrc]="imageUrl()">
        </phx-drag-drop>

        @if (adsForm.get('image')?.hasError('required') && adsForm.get('image')?.touched) {
          <mat-error>
            <small>Bild ist erforderlich</small>
          </mat-error>
        }
      </div>
    </div>

    <div class="row mt-m">
      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Position</mat-label>
          <mat-select formControlName="location">
            @for (location of locations(); track location) {
              <mat-option [value]="location.value">
                {{ location.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Target</mat-label>
          <mat-select formControlName="target">
            @for (target of targets(); track target) {
              <mat-option [value]="target.value">
                {{ target.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Hersteller</mat-label>
          <mat-select formControlName="vendor">
            @for (vendor of vendors(); track vendor.id) {
              <mat-option [value]="vendor.id">
                {{ vendor.name }}
              </mat-option>
            }
          </mat-select>
          @if (adsForm.get('vendor')?.hasError('required')) {
            <mat-error>
              Hersteller ist erforderlich
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>


    <h3 class="pb-2 my-4">Parameter Sichtbarkeit</h3>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Zeitraum</mat-label>
          <mat-date-range-input [rangePicker]="range">
            <input matStartDate placeholder="Start date" formControlName="start">
            <input matEndDate placeholder="End date" formControlName="end">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="range"></mat-datepicker-toggle>
          <mat-date-range-picker #range></mat-date-range-picker>
          <mat-error>Invalid date range</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>IDF liste</mat-label>
          <input
            (change)="insertIdfsAsList($event)"
            formControlName="idfs"
            autocomplete="off"
            matInput
            placeholder="IDF liste">
          </mat-form-field>
          @if (invalid().length > 0) {
            <mat-error>
              <small>These idfs are invalid: {{ invalid().join(', ') }}</small>
            </mat-error>
          }

          <div class="portal-selection">
            <mat-checkbox
              [checked]="isPortalSelected('PHOENIX')"
              (change)="togglePortal('PHOENIX')">
              <img src="assets/img/logo/phoenix-logo_corp.svg" alt="" class="table-logo">
            </mat-checkbox>
            <mat-checkbox
              [checked]="isPortalSelected('HAGEDA')"
              (change)="togglePortal('HAGEDA')">
              <img src="assets/img/logo/hageda-stumpf-logo.svg" alt="" class="table-logo mr-xs">
            </mat-checkbox>
            @if (portals().length === 0) {
              <mat-error>
                <small>Mindestens ein Portal muss ausgewählt werden</small>
              </mat-error>
            }
          </div>
        </div>

        <div class="col-md-6">
          <phx-drag-drop
            (readFiles)="insertIdfs($event)"
            [acceptedFileTypes]="'csv'"
            [invalid]="invalid()">
          </phx-drag-drop>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="btn-secondary mt-0" (click)="onCancel()">Abbrechen</button>
    <button class="btn-primary mt-0" (click)="data.mode === 'edit' ? onEditAd() : onCreateAd()"
      [disabled]="!isFormValid()">
      {{ submitButtonText() }}
    </button>
  </mat-dialog-actions>